import React from 'react';
import {
  Text, OrderedList, UnorderedList, ListItem, Alert, AlertIcon, Code,
} from '@chakra-ui/react';

const generalManual = [
  {
    title: 'Login e Acesso',
    content: (
      <>
        <OrderedList spacing={2} mb={3}>
          <ListItem>Acesse o endereço do painel administrativo no navegador</ListItem>
          <ListItem>Digite seu <strong>email</strong> e <strong>senha</strong></ListItem>
          <ListItem>Clique em <strong>"Entrar"</strong></ListItem>
        </OrderedList>
        <Text mb={2}>Se esquecer a senha:</Text>
        <OrderedList spacing={1} mb={3}>
          <ListItem>Clique em <strong>"Esqueceu a senha?"</strong> na tela de login</ListItem>
          <ListItem>Digite seu email cadastrado</ListItem>
          <ListItem>Verifique sua caixa de entrada e clique no link de redefinição</ListItem>
          <ListItem>Defina uma nova senha</ListItem>
        </OrderedList>
        <Alert status="info" borderRadius="md" fontSize="sm">
          <AlertIcon />
          Sua sessão expira automaticamente após um período de inatividade. Se isso acontecer, basta fazer login novamente.
        </Alert>
      </>
    ),
    keywords: 'login acesso entrar senha esqueceu redefinir sessão',
  },
  {
    title: 'Navegação — Menu Lateral',
    content: (
      <>
        <Text mb={3}>O menu lateral esquerdo é organizado em seções expansíveis (acordeões). Clique em uma seção para expandir e ver os subitens.</Text>
        <UnorderedList ml={6} spacing={1} mb={3}>
          <ListItem><strong>Dashboard</strong> — visão geral com métricas do sistema</ListItem>
          <ListItem><strong>Seções específicas</strong> — dependem do seu perfil de acesso (veja abaixo)</ListItem>
          <ListItem><strong>Ajuda e FAQ</strong> — esta página de manual</ListItem>
        </UnorderedList>
        <Text mb={2}>No canto superior direito do menu, há um ícone de <strong>engrenagem</strong> com:</Text>
        <UnorderedList ml={6} spacing={1}>
          <ListItem><strong>Meu Perfil</strong> — ver seus dados e alterar senha</ListItem>
          <ListItem><strong>Preferências</strong> — configurar notificações, tema escuro, idioma</ListItem>
          <ListItem><strong>Sair</strong> — encerrar a sessão</ListItem>
        </UnorderedList>
      </>
    ),
    keywords: 'navegação menu lateral seções acordeão engrenagem perfil preferências sair',
  },
  {
    title: 'Dashboard',
    content: (
      <>
        <Text mb={3}>
          O Dashboard é a primeira página ao fazer login. Ele mostra métricas e estatísticas relevantes para o seu perfil de acesso.
        </Text>
        <UnorderedList ml={6} spacing={1} mb={3}>
          <ListItem>Use o seletor de <strong>período</strong> (Dia, Semana, Mês, Trimestre, Ano) para alterar o intervalo dos dados</ListItem>
          <ListItem>Clique em <strong>"Atualizar"</strong> para recarregar os dados</ListItem>
          <ListItem>Os cards mostram valores e a <strong>variação percentual</strong> em relação ao período anterior</ListItem>
        </UnorderedList>
        <Alert status="info" borderRadius="md" fontSize="sm">
          <AlertIcon />
          Cada perfil vê um dashboard diferente, focado nas métricas relevantes ao seu trabalho.
        </Alert>
      </>
    ),
    keywords: 'dashboard métricas estatísticas período atualizar cards variação',
  },
  {
    title: 'Meu Perfil e Preferências',
    content: (
      <>
        <Text fontWeight="semibold" mb={2}>Meu Perfil:</Text>
        <UnorderedList ml={6} spacing={1} mb={3}>
          <ListItem>Visualize seu nome, email e permissões</ListItem>
          <ListItem>Para <strong>alterar a senha</strong>: preencha a senha atual, nova senha (mín. 6 caracteres) e confirmação</ListItem>
        </UnorderedList>
        <Text fontWeight="semibold" mb={2}>Preferências:</Text>
        <UnorderedList ml={6} spacing={1}>
          <ListItem><strong>Notificações por email</strong> — ativar/desativar alertas por email</ListItem>
          <ListItem><strong>Sons de notificação</strong> — ativar/desativar sons</ListItem>
          <ListItem><strong>Modo escuro</strong> — alternar entre tema claro e escuro</ListItem>
          <ListItem><strong>Idioma</strong> — Português (Brasil) disponível; outros em breve</ListItem>
        </UnorderedList>
      </>
    ),
    keywords: 'perfil senha preferências notificações modo escuro idioma',
  },
];

export default generalManual;
